import { registerQuery } from 'data-fetching-client';
import { getConnectedForms } from '../clients/cv-forms-integration-legacy.api';
export const fetchConnectedForms = registerQuery({
  fetcher: getConnectedForms,
  fieldName: 'connectedForms'
});